export enum LicenseType {
    DEMO = 0,
    ONETIME = 1,
    FORYEAR = 2,
    FORUSER = 3,
    // ADMSPEC = 4,
    FORYEARPLUS = 5,
    RESPONDENTPANEL = 6,
}

export const LicenseNames = {
    [LicenseType.DEMO]: 'Демо-лицензия',
    [LicenseType.ONETIME]: 'Разовая лицензия',
    [LicenseType.FORUSER]: 'Доп. пользователи',
    [LicenseType.FORYEAR]: 'Годовая лицензия',
    [LicenseType.FORYEARPLUS]: 'Годовая лицензия',
};
